import React from "react";
import PropTypes from "prop-types";

const TabIndicator = ({ num, isDone }) => (
  <span className={`tab__icon tab-indicator ${isDone ? "is-done" : ""}`}>
    {num === 0 || isDone ? (
      <svg className="tab-indicator__icon" viewBox="0 0 100 100">
        <g>
          <path d="M87.8978532,14.004077 C85.3478411,14.0783947 82.9268403,15.1421678 81.1473944,16.9701877 C65.6095892,32.5415734 51.4234958,47.8100639 36.5023144,63.0471177 L18.9613494,48.9837437 C16.2208086,46.7908815 12.5185208,46.2267681 9.2492574,47.5039233 C5.97999401,48.7810784 3.64049991,51.7054461 3.11213806,55.1753225 C2.58377622,58.6451989 3.94682804,62.1333572 6.68778789,64.3256956 L31.2349109,83.963394 C35.1551708,87.0861193 40.7980128,86.7554488 44.3267098,83.1962145 C61.9843228,65.5006845 77.8036016,48.1203395 95.0574307,30.8290024 C97.941163,27.9994029 98.7975518,23.6923661 97.2156166,19.9748365 C95.6336814,16.2573069 91.9363038,13.8880525 87.8978532,14.004077 Z" />
        </g>
      </svg>
    ) : (
      num
    )}
  </span>
);

TabIndicator.propTypes = {
  num: PropTypes.number.isRequired,
  isDone: PropTypes.bool.isRequired
};

export default TabIndicator;
